/* eslint-disable import/no-cycle */

import { Stack, HStack } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import InputPreview from '../formInputs/InputPreview';
import FormLabelInput from '../formInputs/FormLabelInput';
import FormTextInput from '../formInputs/FormTextInput';
import { FormBuilderComponentProps } from '../types';

function DateFieldComponent({ fieldId, labelRightRenderer, isAdvanced }: Omit<FormBuilderComponentProps, 'path'>) {
  const { t } = useTranslation('hrFormTemplate');
  return (
    <Stack>
      <HStack justify="space-between">
        <FormLabelInput fieldId={fieldId} isAdvanced={isAdvanced} />
        {labelRightRenderer}
      </HStack>
      <FormTextInput fieldId={fieldId} placeholder={t('formBuilder.editorPlaceholder.date')} isAdvanced={isAdvanced || false} />
      <InputPreview fieldId={fieldId} value="MM-DD-YYYY" />
    </Stack>
  );
}

export const DateField = React.memo(
  DateFieldComponent,
  (prev, next) =>
    prev.fieldId === next.fieldId || prev.isAdvanced === next.isAdvanced || prev.labelRightRenderer === next.labelRightRenderer,
);
